
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/career-path/[...slug]",
      function () {
        return require("private-next-pages/career-path/[...slug].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/career-path/[...slug]"])
      });
    }
  